import React, { useMemo } from 'react';
import { useGate, useStore } from 'effector-react';
import { parseJsonString } from 'pano-utils';
import { $loadedScene } from '@stores/loadedStore';
import type { StandardSubtitle } from '@utils/subtitleFormat';
import {
  $GateRotateSubtitleLength,
  $GateRotateSubtitleList,
} from '@stores/autoRotateStores';
import { PX_PER_SEC } from '../constants';

interface Props {
  width: number;
}

export const RotateSubtitle = React.memo(({ width }: Props) => {
  const scene = useStore($loadedScene)!;
  const subtitle = scene.config.autoRotate?.subtitle ?? '';
  const list = useMemo(
    () => (parseJsonString(subtitle) as StandardSubtitle[]) ?? [],
    [subtitle]
  );
  useGate(
    $GateRotateSubtitleLength,
    (list[list.length - 1]?.endTime ?? 0) / 1000
  );
  useGate($GateRotateSubtitleList, list);

  const renderItem = (x: StandardSubtitle, i: number) => {
    return (
      <div
        key={i}
        className="absolute flex items-center justify-center rounded px-10 text-sm"
        style={{
          backgroundColor: '#5A7384',
          left: `${(x.startTime / 1000) * PX_PER_SEC}px`,
          width: `${((x.endTime - x.startTime) / 1000) * PX_PER_SEC}px`,
        }}
      >
        <span className="truncate">{x.text}</span>
      </div>
    );
  };

  return (
    <div
      className="relative mt-10 flex h-25 items-center bg-black-#34"
      style={{ width }}
    >
      {list.length ? (
        list.map(renderItem)
      ) : (
        <div className="pl-10 text-black-gray">
          添加已制作好的“讲解字幕”内容，有针对性的设置导览节点。
        </div>
      )}
    </div>
  );
});
